import { AbstractControl } from "@angular/forms";
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'emptyFallback', standalone: true })
export class EmptyFallbackPipe implements PipeTransform {
  transform(value: any, fallback: string = '--'): string {
    if (value === null || value === undefined) return fallback;
    if (typeof value === 'string' && value.trim().length === 0) return fallback;
    return value.toString();
  }
}


export const formatMoney = (amount: number): string => {
  const formattedAmount = Math.abs(amount).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  if (amount < 0) {
    return `$ (${formattedAmount})`;
  }else if(amount == 0)
  {
    return `$ 0.00`
  }
  return `$${formattedAmount}`;
};

export const isNullOrEmptyOrWhitespace=(value: any): boolean => {
  return (
    value === null ||
    value === undefined ||
    (typeof value === 'string' && value.trim().length === 0)
  );
}

export const dateRangeValidator=(control: AbstractControl): { [key: string]: boolean } | null =>{
 const startDate = control.get('startDate')?.value;
  const endDate = control.get('endDate')?.value;
  console.log('startDate:', startDate, 'endDate:', endDate, 'isNullOrEmptyOrWhitespace(endDate):', isNullOrEmptyOrWhitespace(endDate));
  if (startDate && isNullOrEmptyOrWhitespace(endDate)) {
    return { endDateRequired: true };
  }
  if (startDate && endDate && endDate < startDate) {
    return { dateRangeInvalid: true };
  }
  return null;
}

export const formatDateforBAT =(date: Date, isEndDate: boolean = false): string => {
  if (!date) return null;
  const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  if (isEndDate) {
    utcDate.setUTCHours(23, 59, 59, 999);
  } else {
    utcDate.setUTCHours(0, 0, 0, 0);
  }
  return utcDate.toISOString();
}


export enum BillingAdjustmentStatusEnum {
  Submitted = 1,
  Approved = 2,
  FirstLevelRejected = 4,
  MIApproved = 5,
  NeedMoreInformation = 3,
  Completed = 6,
  Received = 7,
  WaitingForApproval = 8,
  SentToCorrections = 9,
  PendingRebill = 10,
  Rejected = 11,
  
  GBSNeedMoreInformation = 13,
  Cancelled = 14,
  Saved = 15,
  PRSSubmitted = 16,
  CompletedRefundInfoNeeded = 17,
  SecondLevelRejected = 18,
  SecondLevelNeedMoreInformation = 19,
  FirstLevelApproved = 20,
  // Backward-compatible alias for existing references.
  SecondLevelPending = FirstLevelApproved
}


export const BillingAdjustmentStatusEnumDisplay: { [key in BillingAdjustmentStatusEnum]: string } = {
  [BillingAdjustmentStatusEnum.Submitted]: 'Submitted',
  [BillingAdjustmentStatusEnum.Approved]: 'Approved',
  [BillingAdjustmentStatusEnum.MIApproved]: 'MI Approved',
  [BillingAdjustmentStatusEnum.FirstLevelRejected]: 'First Level Rejected',
  [BillingAdjustmentStatusEnum.NeedMoreInformation]: 'First Level Need More Information',
  [BillingAdjustmentStatusEnum.Completed]: 'Completed',
  [BillingAdjustmentStatusEnum.Received]: 'Received',
  [BillingAdjustmentStatusEnum.WaitingForApproval]: 'Waiting For Approval',
  [BillingAdjustmentStatusEnum.SentToCorrections]: 'Sent To Corrections',
  [BillingAdjustmentStatusEnum.PendingRebill]: 'Pending Rebill',
  [BillingAdjustmentStatusEnum.Rejected]: 'GBS Rejected',
  [BillingAdjustmentStatusEnum.CompletedRefundInfoNeeded]: 'Completed - Refund info is needed',
  [BillingAdjustmentStatusEnum.GBSNeedMoreInformation]: 'GBS Need More Information',
  [BillingAdjustmentStatusEnum.Cancelled]: 'Cancelled',
   [BillingAdjustmentStatusEnum.Saved]: 'Saved',
   [BillingAdjustmentStatusEnum.PRSSubmitted] : 'Submitted',
   [BillingAdjustmentStatusEnum.SecondLevelRejected]: 'Second Level Rejected',
   [BillingAdjustmentStatusEnum.SecondLevelNeedMoreInformation]: 'Second Level Need More Information',
  [BillingAdjustmentStatusEnum.FirstLevelApproved]: 'First Level Approved'
};


export const formatDateRange = (date: Date | string, isEndDate: boolean = false): string | null => {

  if (!date) return null;

  const validDate = (date instanceof Date) ? date : new Date(date);
  if (isNaN(validDate.getTime())) {
    console.error("Invalid date provided:", date);
    return null;
  }

  const utcDate = new Date(Date.UTC(validDate.getFullYear(), validDate.getMonth(), validDate.getDate()));

  if (isEndDate) {
    utcDate.setUTCHours(23, 59, 59, 999);
  } else {
    utcDate.setUTCHours(0, 0, 0, 0);
  }

  return utcDate.toISOString();
}

  export interface FilterDto {
  column: string;   
  operator: string;
  value: string;  
}

